import {
    handle,
    loader,
    default as ProfessionalProjectsRoute,
} from '~/routes/_app.professional.$urlSegment.case-studies.$';

export { loader, handle };
export default ProfessionalProjectsRoute;
